import { useState, createContext, useContext } from "react"
import type { ReactNode } from "react"

interface FocusManagerContextType {
	announcePageChange: (message: string) => void
}

const FocusManagerContext = createContext<FocusManagerContextType | null>(null)

export const useFocusManager = () => {
	const context = useContext(FocusManagerContext)
	if (!context) {
		throw new Error("useFocusManager must be used within FocusManagerProvider")
	}
	return context
}

interface FocusManagerProviderProps {
	children: ReactNode
}

export const FocusManagerProvider = ({
	children
}: FocusManagerProviderProps) => {
	const [announcement, setAnnouncement] = useState<string>("")

	const announcePageChange = (message: string) => {
		setAnnouncement(message)
		setTimeout(() => setAnnouncement(""), 3000)
	}

	return (
		<FocusManagerContext.Provider value={{ announcePageChange }}>
			{children}
			<div
				aria-live="polite"
				aria-atomic="true"
				className="sr-only"
				style={{
					position: "absolute",
					left: "-10000px",
					width: "1px",
					height: "1px",
					overflow: "hidden"
				}}
			>
				{announcement}
			</div>
		</FocusManagerContext.Provider>
	)
}
